module.exports = __webpack_public_path__ + "img/marker-home-purple.66f50743.svg";